import React, { memo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  Badge,
  Zoom,
  Tooltip,
  AppBar,
  Grid,
  Button,
} from "@material-ui/core";
import {
  Assessment,
  ContactsOutlined,
  PeopleAltOutlined,
  LocalAtm,
  DescriptionOutlined,
  PermMediaOutlined,
  StoreOutlined,
  CollectionsBookmarkOutlined,
  Send,
} from "@material-ui/icons";
import { ListaDocumentacion } from "../Documentacion/ListaDocumentacion";
import { GrillaGrupoFamiliar } from "./GrillaGrupoFamiliar";
import { Observaciones } from "./Observaciones";
import { EmpresasAfiliado } from "./EmpresasAfiliado";
import { CertificadosAfiliado } from "./CertificadosAfiliado";
import { PanelDatos } from "./PanelDatos";
import { GrillaAportes } from "./GrillaAportes";
import { GrillaMovimientos } from "./GrillaMovimientos";
import { VisualizadorReportes } from "../reportes/VisualizadorReportes";
import ModalCredenciales from "../compartidos/ModalCredenciales";
import { ReactivacionesModal } from "./Reactivaciones/components/ReactivacionesModal";
import { getValidacionDataPersonal } from "../../actions/afiliado/afiliadoReactivacionAction";
import { OBRAS_SOCIALES, TIPO_CERTIFICADOS } from "../../utils/constants";
import { 
  fetchAportes 
} from "../../actions/aportes";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  customBadge: {
    backgroundColor: "#00AFD7",
    color: "white",
  },
  customBadgeEmpresa: {
    backgroundColor: "#00AF34",
    color: "white",
  },
  customBadgeEmpresaCero: {
    backgroundColor: "#ff0000",
    color: "white",
  },
  docuCompleta: {
    backgroundColor: "#008000",
    color: "white",
  },
  docuIncompleta: {
    backgroundColor: "#ff0000",
    color: "white",
  },
  certificadosError: {
    backgroundColor: "#ff0000",
    color: "white",
  },
}));

export default memo(function ScrollableTabsButtonForce(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const [openCredenciales, setOpenCredenciales] = useState(false);
  const [reactivacionModal, setReactivacionModal] = useState(false);
  const [afiliadoSeleccionado, setAfiliadoSeleccionado] = useState({});
  const [abrirConstancia, setAbrirConstancia] = useState(false);
  const [empresasAfiliadoActuales, setEmpresasAfiliadoActuales] = useState([]);
  const [esDiscapacitado, setEsDiscapacitado] = useState(false);

  const { items: grupoFamiliar } = useSelector((state) => state.grupofamiliar);
  const { items: empresasAfiliado } = useSelector(
    (state) => state.empresasAfiliado
  );
  const { items: certificadosAfiliado } = useSelector(
    (state) => state.certificadosAfiliacion
  );
  const { items: observaciones } = useSelector(
    (state) => state.observacionesAfiliacion
  );
  const { documentacionCompleta, datosCompletos, afiliado, consultaAfiliado } =
    useSelector((state) => state.afiliacion);

  const hayCertificadoDiscapacitado =
    certificadosAfiliado.filter(
      (certificado) =>
        certificado.tipoCertificado === TIPO_CERTIFICADOS.DISCAPACIDAD
    ).length > 0;

  useEffect(() => {
    props.fromCambioFamiliar ? setTab(1) : setTab(0);
  }, [props.fromCambioFamiliar]);

  useEffect(() => {
    if (consultaAfiliado && Object.keys(consultaAfiliado).length > 0) {
      setAfiliadoSeleccionado(consultaAfiliado);
    } else {
      if (afiliado && Object.keys(afiliado).length > 0) {
        setAfiliadoSeleccionado(afiliado);
      }
    }
  }, [afiliado, consultaAfiliado]);

  useEffect(() => {
    setEmpresasAfiliadoActuales(
      empresasAfiliado.filter((empresa) => {
        if (
          empresa.fechaHasta === null ||
          new Date(empresa.fechaHasta) > new Date()
        ) {
          return true;
        } else {
          return false;
        }
      })
    );
  }, [empresasAfiliado]);

  useEffect(() => {
    dispatch(
      getValidacionDataPersonal(
        afiliado.id_afiliado || consultaAfiliado.id_afiliado
      )
    );
    // eslint-disable-next-line
  }, [afiliado.id_afiliado, consultaAfiliado.id_afiliado]);

  useEffect(() => {
    if(tab === 5)
    dispatch(fetchAportes(afiliado.cuil || consultaAfiliado?.cuil));
    
  }, [afiliado.cuil, consultaAfiliado?.cuil]);

  const handleChange = (e, tabselec) => { 
    if (tabselec === 5)
      dispatch(fetchAportes(afiliado.cuil || consultaAfiliado?.cuil));
    
    setTab(tabselec);
  };

  console.log(afiliadoSeleccionado);

  return (
    //  TAB TITULAR
    <>
      {props.isReactivaciones && (
        <Grid item xs={12} styles={{ padding: 5 }}>
          <Button
            style={{ float: "right", marginBottom: "1rem" }}
            color="primary"
            variant="contained"
            onClick={() => setReactivacionModal(true)}
            endIcon={<Send />}
          >
            REACTIVAR
          </Button>
          <ReactivacionesModal
            idUsuario={afiliadoSeleccionado.id_afiliado}
            abrirModal={reactivacionModal}
            setAbrirModal={setReactivacionModal}
          />
        </Grid>
      )}
      {afiliadoSeleccionado.id_parentesco === 0 && (
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={tab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="off"
              indicatorColor="primary"
              textColor="primary"
              aria-label="scrollable"
            >
              <Tab
                label="Datos Personales"
                icon={
                  <Badge
                    classes={
                      datosCompletos === true
                        ? {
                            badge: classes.docuCompleta,
                          }
                        : {
                            badge: classes.docuIncompleta,
                          }
                    }
                    badgeContent={datosCompletos === true ? `Ok` : `X`}
                  >
                    <ContactsOutlined />
                  </Badge>
                }
                {...a11yProps(0)}
              />
              <Tab
                label="Grupo Familiar"
                icon={
                  <Badge badgeContent={grupoFamiliar.length} color="secondary">
                    <PeopleAltOutlined style={{ padding: 0 }} />
                  </Badge>
                }
                {...a11yProps(1)}
              />
              <Tab
                label="Documentación"
                icon={
                  <Badge
                    classes={
                      documentacionCompleta
                        ? {
                            badge: classes.docuCompleta,
                          }
                        : {
                            badge: classes.docuIncompleta,
                          }
                    }
                    badgeContent={documentacionCompleta === true ? `Ok` : `X`}
                  >
                    <Tooltip
                      title={
                        documentacionCompleta
                          ? "Documentacion completa"
                          : "Adeuda documentación"
                      }
                    >
                      <PermMediaOutlined />
                    </Tooltip>
                  </Badge>
                }
                {...a11yProps(2)}
              />
              <Tab
                label="Empresas"
                icon={
                  <Badge
                    classes={
                      empresasAfiliadoActuales?.length > 0
                        ? {
                            badge: classes.customBadgeEmpresa,
                          }
                        : {
                            badge: classes.customBadgeEmpresaCero,
                          }
                    }
                    badgeContent={empresasAfiliadoActuales.length || "0"}
                  >
                    <StoreOutlined />
                  </Badge>
                }
                {...a11yProps(3)}
              />
              <Tab
                label="Certificados"
                icon={
                  <Badge
                    classes={
                      esDiscapacitado && !hayCertificadoDiscapacitado
                        ? { badge: classes.certificadosError }
                        : { badge: classes.customBadge }
                    }
                    badgeContent={
                      esDiscapacitado && !hayCertificadoDiscapacitado
                        ? "X"
                        : certificadosAfiliado.length
                    }
                  >
                    <CollectionsBookmarkOutlined />
                  </Badge>
                }
                {...a11yProps(4)}
              />
              <Tab label="Aportes" icon={<LocalAtm />} {...a11yProps(5)} />
              {props.idForm !== "formConsulta" && (
                <Tab
                  label="Observaciones"
                  icon={
                    <Badge
                      classes={{ badge: classes.customBadge }}
                      badgeContent={observaciones.length}
                    >
                      <DescriptionOutlined />
                    </Badge>
                  }
                  {...a11yProps(6)}
                />
              )}
              {props.idForm !== "formConsulta" && (
                <Tab
                  label="Movimientos"
                  icon={<Assessment />}
                  {...a11yProps(7)}
                />
              )}
            </Tabs>
          </AppBar>
          <Zoom style={{ transitionDelay: "100ms" }} in={tab === 0}>
            <TabPanel value={tab} index={0}>
              <>
                <PanelDatos
                  idPanel={
                    props.idForm === "formConsulta"
                      ? "idTabConsulta"
                      : "idTabAfiliacion"
                  }
                  {...{ setAbrirConstancia }}
                  openModalCredenciales={() => setOpenCredenciales(true)}
                  esModificacion={props.esModificacion}
                  esReactivacion={props.isReactivaciones}
                  setEsDiscapacitado={setEsDiscapacitado}
                />
                <ModalCredenciales
                  open={openCredenciales}
                  setOpen={setOpenCredenciales}
                  desdeBandejaAceptadas={props.desdeBandejaAceptadas}
                  idObraSocial={OBRAS_SOCIALES.OSPEDYC}
                />
                <VisualizadorReportes
                  abrirModal={abrirConstancia}
                  afiliado={afiliadoSeleccionado}
                  setAbrirModal={setAbrirConstancia}
                  reporte="Constancia"
                />
              </>
            </TabPanel>
          </Zoom>
          <Zoom style={{ transitionDelay: "100ms" }} in={tab === 1}>
            <TabPanel value={tab} index={1}>
              <GrillaGrupoFamiliar idForm={props.idForm} setTab={setTab} esModificacion={props.esModificacion} />
            </TabPanel>
          </Zoom>
          <TabPanel value={tab} index={2}>
            <ListaDocumentacion idForm={props.idForm} />
          </TabPanel>
          <Zoom style={{ transitionDelay: "500ms" }} in={tab === 3}>
            <TabPanel value={tab} index={3}>
              <EmpresasAfiliado idForm={props.idForm} isReactivaciones={props.isReactivaciones} />
            </TabPanel>
          </Zoom>
          <Zoom style={{ transitionDelay: "500ms" }} in={tab === 4}>
            <TabPanel value={tab} index={4}>
              <CertificadosAfiliado idForm={props.idForm} />
            </TabPanel>
          </Zoom>
          <TabPanel value={tab} index={5}>
            <GrillaAportes />
          </TabPanel>
          <Zoom style={{ transitionDelay: "500ms" }} in={tab === 6}>
            <TabPanel value={tab} index={6}>
              <Observaciones idForm={props.idForm} />
            </TabPanel>
          </Zoom>
          <TabPanel value={tab} index={7}>
            <GrillaMovimientos />
          </TabPanel>
        </div>
      )}
      {afiliadoSeleccionado.id_parentesco > 0 && (
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={tab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              aria-label="scrollable"
            >
              <Tab
                label="Datos Personales"
                icon={
                  <Badge
                    classes={
                      datosCompletos !== true
                        ? {
                            badge: classes.docuCompleta,
                          }
                        : {
                            badge: classes.docuIncompleta,
                          }
                    }
                    badgeContent={datosCompletos !== true ? `Ok` : `X`}
                  >
                    <ContactsOutlined />
                  </Badge>
                }
                {...a11yProps(0)}
              />
              <Tab
                label="Grupo Familiar"
                icon={
                  <Badge badgeContent={grupoFamiliar.length} color="secondary">
                    <PeopleAltOutlined style={{ padding: 0 }} />
                  </Badge>
                }
                {...a11yProps(1)}
              />
              <Tab
                label="Documentacion"
                icon={
                  <Badge
                    classes={
                      documentacionCompleta
                        ? {
                            badge: classes.docuCompleta,
                          }
                        : {
                            badge: classes.docuIncompleta,
                          }
                    }
                    badgeContent={documentacionCompleta === true ? `Ok` : `X`}
                  >
                    <Tooltip
                      title={
                        documentacionCompleta
                          ? "Documentacion completa"
                          : "Adeuda documentación"
                      }
                    >
                      <PermMediaOutlined />
                    </Tooltip>
                  </Badge>
                }
                {...a11yProps(2)}
              />
              <Tab
                label="Certificados"
                icon={
                  <Badge
                    classes={
                      esDiscapacitado && !hayCertificadoDiscapacitado
                        ? { badge: classes.certificadosError }
                        : { badge: classes.customBadge }
                    }
                    badgeContent={
                      esDiscapacitado && !hayCertificadoDiscapacitado
                        ? "X"
                        : certificadosAfiliado.length
                    }
                  >
                    <CollectionsBookmarkOutlined />
                  </Badge>
                }
                {...a11yProps(3)}
              />
              {props.idForm !== "formConsulta" && (
                <Tab
                  label="Observaciones"
                  icon={
                    <Badge
                      classes={{ badge: classes.customBadge }}
                      badgeContent={observaciones.length}
                    >
                      <DescriptionOutlined />
                    </Badge>
                  }
                  {...a11yProps(4)}
                />
              )}
              {props.idForm !== "formConsulta" && (
                <Tab
                  label="Movimientos"
                  icon={<Assessment />}
                  {...a11yProps(5)}
                />
              )}
            </Tabs>
          </AppBar>
          <Zoom style={{ transitionDelay: "100ms" }} in={tab === 0}>
            <TabPanel value={tab} index={0}>
              <>
                <PanelDatos
                  idPanel={
                    props.idForm === "formConsulta"
                      ? "idTabConsulta"
                      : "idTabAfiliacion"
                  }
                  setAbrirConstancia={setAbrirConstancia}
                  openModalCredenciales={() => setOpenCredenciales(true)}
                  esModificacion={props.esModificacion}
                  esReactivacion={props.isReactivaciones}
                  setEsDiscapacitado={setEsDiscapacitado}
                />
                <ModalCredenciales
                  open={openCredenciales}
                  setOpen={setOpenCredenciales}
                  desdeBandejaAceptadas={props.desdeBandejaAceptadas}
                  idObraSocial={OBRAS_SOCIALES.OSPEDYC}
                />
                <VisualizadorReportes
                  abrirModal={abrirConstancia}
                  afiliado={afiliadoSeleccionado}
                  setAbrirModal={setAbrirConstancia}
                  reporte="Constancia"
                />
              </>
            </TabPanel>
          </Zoom>
          <Zoom style={{ transitionDelay: "100ms" }} in={tab === 1}>
            <TabPanel value={tab} index={1}>
              <GrillaGrupoFamiliar idForm={props.idForm} setTab={setTab} esModificacion={props.esModificacion} />
            </TabPanel>
          </Zoom>
          <TabPanel value={tab} index={2}>
            <ListaDocumentacion idForm={props.idForm} />
          </TabPanel>
          <Zoom style={{ transitionDelay: "500ms" }} in={tab === 3}>
            <TabPanel value={tab} index={3}>
              <CertificadosAfiliado idForm={props.idForm} />
            </TabPanel>
          </Zoom>
          <Zoom style={{ transitionDelay: "500ms" }} in={tab === 4}>
            <TabPanel value={tab} index={4}>
              <Observaciones idForm={props.idForm} />
            </TabPanel>
          </Zoom>
          <TabPanel value={tab} index={5}>
            <GrillaMovimientos />
          </TabPanel>
        </div>
      )}
    </>
  );
});
